import React, { useEffect } from "react";
import _ from "lodash";
import { motion } from "framer-motion/dist/framer-motion";
import grayEye from "../../../assets/images/ct/gray-eyes.png";
import eyeUnderline from "assets/images/ct/eye-underline.png";
import techImg from "../../../assets/images/ct/tech.png";
import {
  divVariants,
  fadeVariants,
  staticBounceVariants
} from "shared/components/animations";
const ActiveDoubleContainer = ({
  TopIcon,
  boldHeading = "",
  smallHeading = "",
  text = "",
  isFour = false,
  buttonText = "",
  secondButtonText = "",
  buttonPress = () => {},
  secondButtonPress = () => {},
  discardPileImage,
  isDiscardPile = false,buzzer_sound,default_audio_effect
}) => {
  useEffect(() => {
    if (  !_.isEmpty(default_audio_effect)) {
      buzzer_sound();
    }
  }, [buzzer_sound, default_audio_effect]);
  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="double-dice-wrapper"
    >
      <div className="double-dice">
        <motion.div variants={fadeVariants}>
          <img src={TopIcon} className="img-fluid image" alt="grayEye" />
          <h2 className="heading">{boldHeading}</h2>
          <h2 className="small-heading">{smallHeading}</h2>
          <img src={eyeUnderline} className="img-fluid line" alt="" />
          <p className="desc">{text}</p>
        </motion.div>
        <motion.div variants={staticBounceVariants} style={{ width: "91%" }}>
          {isFour && (
            <button
              className="ct-btn-green move-btn mb-2 w-100"
              onClick={secondButtonPress}
            >
              {secondButtonText}
            </button>
          )}
          {isDiscardPile && (
            <img
              src={discardPileImage}
              className="img-fluid rect-img"
              alt="techImg"
            />
          )}
          <button className="ct-btn-gray roll-btn w-100" onClick={buttonPress}>
            {buttonText}
          </button>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default ActiveDoubleContainer;
